import { createMDWrapper, getText } from "shared/lib";

export interface ReviewProposalProps {
  content: string;
}

export function ReviewProposal({ content }: ReviewProposalProps) {
  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-1">
        <h2 className="text-headingxl text-textPrimary">
          {getText("Review proposal")}
        </h2>

        <p className="text-bodylg text-textSubdued">
          {getText(
            "We've generated a summary of your proposal based on your responses. Check if everything is correct before proceeding.",
          )}
        </p>
      </div>

      <div className="flex flex-col gap-2">
        <h3 className="text-headingmd">{getText("Summary")}</h3>

        <span className="text-textPrimary text-bodysm">
          {createMDWrapper(content, {
            components: {
              h1({ children }) {
                return <h5 className="text-bodymd font-bold">{children}</h5>;
              },
              h2({ children }) {
                return <h5 className="text-bodymd font-bold">{children}</h5>;
              },
              h3({ children }) {
                return <h5 className="text-bodymd font-bold">{children}</h5>;
              },
              h4({ children }) {
                return <h5 className="text-bodymd font-bold">{children}</h5>;
              },
            },
          })}
        </span>
      </div>
    </div>
  );
}
